import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import MyCard from './mycard'

class Solicitud extends React.Component{
    constructor(param){
        super(param)
        this.state={
            xpbuscar:"",
            registros:[]
        }
    }

    handleKeyPress=(e)=>{        
        if (e.key==="Enter"){
          this.handleBuscar();
        }
    }
    handleChange=(e)=>{
          let vbuscar=e.target.value;        
          this.setState({"xpbuscar":vbuscar})
    }
    handleCancelar=(e)=>{        
        document.getElementById("cbBusqueda").value="0";
        document.getElementById("cbTipo").value="0";
        document.getElementById("txtbuscar").value="";
        this.setState({"registros":[]})
    }
    validarFormulario = ()=>{
      let dev = true;
      let v1= document.getElementById("cbBusqueda").value;
      let v2= document.getElementById("cbTipo").value;      
      if (v1==="0" || v2==="0") dev = false;
      return dev;
    }

    handleBuscar=(e)=>{        
        if (!this.validarFormulario()){
           alert("seleccionar para poder consultar");
           return;
        }
        let vbuscar=this.state.xpbuscar;
        let cbBusqueda1 = document.getElementById("cbBusqueda").value;
        let cbTipo1 = document.getElementById("cbTipo").value;        

        if (vbuscar.length>0){
                let frmInicio = new FormData();
                let opc = {
                        opc:1,
                        data:{
                            tipo:cbTipo1,
                            nombre:cbBusqueda1==="2"?vbuscar:"",
                            inscripcion:cbBusqueda1==="1"?vbuscar:0
                        }
                };
                frmInicio.append("data",JSON.stringify(opc));
                fetch("../../servicios/inscritos/",
                {
                    method: 'POST',
                    body: frmInicio,
                }
                )
                .then(ret=>ret.json())
                .then(ret=>{                        
                if (ret.success){                    
                    this.setState({"registros":ret.data})
                }                
                });                       
      }
    }

    render(){        
        let formulario = (            
            <div className="container">
            <br/>
            <br/>
            <br/>
            <h3 style={{maxWidth:700+'px',margin:0+' Auto'}}>Consulta de Personas Inscritas.</h3>
            <div style={{maxWidth:700+'px',margin:0+' Auto'}} className="justify-content-center box-1-shadow">
            
                <div className="form-group">
                  <div className="col-md-12">
                    <label for="cbTipo">Seleccionar si es Auditor o Contador </label>
                    <select id="cbTipo" className="form-control">
                        <option value="0">Seleccionar si es Auditor o Contador</option>
                        <option value="A">Auditor</option>
                        <option value="C">Contador</option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                    <div className="col-md-12">
                        <label for="cbBusqueda">Seleccionar Busqueda</label>
                        <select id="cbBusqueda" className="form-control">
                            <option value="0">Seleccionar Busqueda</option>
                            <option value="1">#. de Inscripci&oacute;n</option>
                            <option value="2">Nombre</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-md-12">
                        <label for="txtbuscar">Digitar</label>
                        <input id="txtbuscar" name="txtbuscar" onChange={this.handleChange} onKeyPressCapture={this.handleKeyPress} className="form-control" type="text" placeholder="Digitar" />
                    </div>  
                </div>                
                
                <div className="form-row p-3">                 
                  <div className="col-md-4">
                    <button id="btnBuscar" onClick={()=>this.handleBuscar()}  className="form-control btn btn-primary">Buscar</button>
                  </div>
                  <div className="col-md-4">
                    <button id="btnCancelar" onClick={this.handleCancelar} className="form-control btn btn-secondary">Limpiar</button>
                  </div>
                  <div className="col-md-4">
                    <button id="btnRegresar" onClick={()=>window.history.back()} className="form-control btn btn-secondary">Regresar</button>
                  </div>                                     
                </div>
                <hr/>
              </div>              
            </div>

        )
        return (
            <>
             { formulario }
             <div className="justify-content-center" style={{margin:0+'Auto',width: 100+'%', maxHeight: 460+'px',height:100+'%', overflowY: 'scroll'}}>
               <MyCard value={this.state.registros}/>
             </div>
            </>
        )
    }
}
export default Solicitud;